import { useTheme, useMediaQuery } from '@mui/material'
import { useState } from 'react'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { TOOL_TABS } from './Constants'
import { useAppSelector } from 'redux/Hook'

// hook to return common values for the ToolBuilder component
export function useToolBuilder() {
  const theme = useTheme()
  const navigate = useNavigate()
  const location = useLocation()
  const isMd = useMediaQuery(theme.breakpoints.down('md'))
  const [toolTabValue, setToolTabValue] = useState(0)
  const { id } = useAppSelector((state) => state.toolBuilder.toolBuilder)
  const { t } = useTranslation()

  const [livePreviewWidth, setLivePreviewWidth] = useState<
    '100%' | '414px' | '768px'
  >('100%')

  const [searchParams] = useSearchParams()
  const toolId = searchParams.get('tool_id') ?? id
  const projectId = searchParams.get('project_id')
  const toolType = searchParams.get('tool_type') as 'Brainstormer'

  const addToolIdToQueryParams = (id: string) => {
    const queryParams = new URLSearchParams(location.search)

    queryParams.set('tool_id', id)

    // Replace the current entry in the history stack with the new query parameter
    navigate(`${location.pathname}?${queryParams.toString()}`, {
      replace: true,
    })
  }

  const toolUrls = {
    Brainstormer: `/embeds/projects/${projectId}/brainstormers/${toolId}`,
  }

  const toolTabs = [t(TOOL_TABS.FIRST), t(TOOL_TABS.SECOND)]

  return {
    isMd,
    toolTabs,
    toolTabValue,
    setToolTabValue,
    livePreviewWidth,
    setLivePreviewWidth,
    toolId,
    toolType,
    projectId,
    toolUrl: toolUrls[toolType] ?? '',
    addToolIdToQueryParams,
  }
}
